
export enum TaskViewLayout {

    DETAILS     = 'details', // info on left messages on right ... clickup style ?
    DEFAULT     = 'default', // goodday like ...
    SIDEPANEL   = 'sidepanel', // tabs
}


